

/* =========================
   7) src/lib/auth.js
========================= */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { api, setAuthToken, getAuthToken } from './api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      api.auth.me()
        .then((res) => {
          setUser(res.data);
        })
        .catch((err) => {
          // Only clear the token on an explicit 401 (invalid/expired).
          // A network timeout (err.response is undefined) on a cold Render
          // start must NOT log the user out — the token is still valid.
          if (err?.response?.status === 401) {
            setAuthToken(null);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await api.auth.login({ email, password });
    setAuthToken(response.data.token);
    setUser(response.data.user);
    return response.data;
  };

  const signup = async (payload) => {
    const response = await api.auth.signup(payload);
    setAuthToken(response.data.token);
    setUser(response.data.user);
    return response.data;
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
  };

  const hasRole = (roles) => {
    if (!user) return false;
    return roles.includes(user.role);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
